import {LinkUserData} from "../../../../types/Link";
import {useCallback, useMemo, useState} from "react";
import {StringUtil} from "zavadil-ts-common";
import Modal from "react-bootstrap/Modal";
import {Button, Form, Stack} from "react-bootstrap";
import {FormRowControl} from "zavadil-react-common";

export type LinkFormProps = {
	link: LinkUserData;
	onSaved: (link: LinkUserData) => void;
	onClosed: () => void;
}

export default function LinkForm({link, onSaved, onClosed}: LinkFormProps) {
	const [data, setData] = useState<LinkUserData>({...link});
	const [isChanged, setIsChanged] = useState(false);

	const isUrlValid = useMemo(() => StringUtil.notBlank(data.url), [data]);
	const isNameValid = useMemo(() => StringUtil.notBlank(data.name), [data]);
	const isValid = useMemo(() => isUrlValid && isNameValid, [isUrlValid, isNameValid]);

	const onChanged = useCallback(
		() => {
			setIsChanged(true);
			setData({...data});
		},
		[data]
	);

	const save = useCallback(
		() => {
			onSaved(data);
		},
		[data, onSaved]
	);

	return (
		<Modal
			show={true}
			onHide={onClosed}
			backdropClassName="secondary-modal"
			dialogClassName="secondary-modal"
			centered={true}
		>
			<Modal.Header closeButton className={`text-default`}>
				<Modal.Title>Editace odkazu</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form onSubmit={save}>
					<Stack gap={2}>
						<div>
							<FormRowControl
								label="URL"
								type="text"
								minLength={1}
								maxLength={255}
								value={data.url}
								onChange={(e) => {
									data.url = e.target.value;
									onChanged();
								}}
							/>
							{
								(isUrlValid === false) && <small className="error">Prosím vložte URL odkazu.</small>
							}
						</div>
						<div>
							<FormRowControl
								label="Název"
								type="text"
								minLength={1}
								maxLength={255}
								value={data.name}
								onChange={(e) => {
									data.name = e.target.value;
									onChanged();
								}}
							/>
							{
								(isNameValid === false) && <small className="error">Prosím vložte název odkazu.</small>
							}
						</div>
						<div>
							<FormRowControl
								label="Popis"
								type="text"
								minLength={1}
								maxLength={255}
								value={StringUtil.toString(data.description)}
								onChange={(e) => {
									data.description = StringUtil.emptyToNull(e.target.value);
									onChanged();
								}}
							/>
						</div>
					</Stack>
				</Form>
				<div className="d-flex justify-content-center gap-2 mt-2">
					<Button
						variant="secondary"
						onClick={onClosed}
						className="mr-2"
					>Zavřít</Button>
					<Button onClick={save} disabled={!(isValid && isChanged)}>Uložit</Button>
				</div>
			</Modal.Body>
		</Modal>
	)
}
